"use client";

import { c as _c } from "react/compiler-runtime";
import { SocialLink, type SocialPlatform } from "@repo/design-system/components/social-link";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { getCurrentYear } from "@repo/design-system/utils/date-helpers";
import { useLanguage } from "~/translations/loader/use-language";
export default function Footer() {
  const $ = _c(51);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.footer_link_instagram || $[1] !== t.footer_title_instagram) {
    t0 = {
      platform: "instagram",
      href: t.footer_link_instagram,
      title: t.footer_title_instagram
    };
    $[0] = t.footer_link_instagram;
    $[1] = t.footer_title_instagram;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.footer_link_youTube || $[4] !== t.footer_title_youTube) {
    t1 = {
      platform: "youtube",
      href: t.footer_link_youTube,
      title: t.footer_title_youTube
    };
    $[3] = t.footer_link_youTube;
    $[4] = t.footer_title_youTube;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t.footer_link_linkedIn || $[7] !== t.footer_title_linkedIn) {
    t2 = {
      platform: "linkedin",
      href: t.footer_link_linkedIn,
      title: t.footer_title_linkedIn
    };
    $[6] = t.footer_link_linkedIn;
    $[7] = t.footer_title_linkedIn;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = [t0, t1, t2];
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const socials = t3;
  let t4;
  if ($[13] !== t.footer_imprint || $[14] !== t.footer_link_imprint) {
    t4 = {
      href: t.footer_link_imprint,
      text: t.footer_imprint
    };
    $[13] = t.footer_imprint;
    $[14] = t.footer_link_imprint;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t.footer_privacyPolicy) {
    t5 = {
      href: "/privacy",
      text: t.footer_privacyPolicy
    };
    $[16] = t.footer_privacyPolicy;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t.footer_link_termsOfUse || $[19] !== t.footer_termsOfUse) {
    t6 = {
      href: t.footer_link_termsOfUse,
      text: t.footer_termsOfUse
    };
    $[18] = t.footer_link_termsOfUse;
    $[19] = t.footer_termsOfUse;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t.footer_contact || $[22] !== t.footer_link_contact) {
    t7 = {
      href: t.footer_link_contact,
      text: t.footer_contact
    };
    $[21] = t.footer_contact;
    $[22] = t.footer_link_contact;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t.footer_PKI || $[25] !== t.footer_link_PKI) {
    t8 = {
      href: t.footer_link_PKI,
      text: t.footer_PKI
    };
    $[24] = t.footer_PKI;
    $[25] = t.footer_link_PKI;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = [t4, t5, t6, t7, t8];
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const footerLinks = t9;
  let t10;
  if ($[33] !== socials) {
    t10 = <ul aria-label="Social media" className="mb-7 flex h-8 items-center lg:mb-auto lg:h-auto">{socials.map(_temp)}</ul>;
    $[33] = socials;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== footerLinks) {
    t11 = footerLinks.map(_temp2);
    $[35] = footerLinks;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t.footer_privacySettings) {
    t12 = <li><button className="cursor-pointer text-foreground first:ml-0 hover:text-primary md:mx-3" data-source="lc" onClick={_temp3} type="button">{t.footer_privacySettings}</button></li>;
    $[37] = t.footer_privacySettings;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t11 || $[40] !== t12) {
    t13 = <ul className="mb-9 grid justify-start font-medium text-sm leading-6 md:flex md:w-[60%] md:justify-end lg:m-auto lg:flex-wrap lg:justify-start">{t11}{t12}</ul>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t10 || $[43] !== t13) {
    t14 = <div className="flex flex-col md:flex-row md:justify-between lg:w-[70%] lg:gap-x-4">{t10}{t13}</div>;
    $[42] = t10;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p data-source="text">{`© E.ON SE ${getCurrentYear()}`}</p>;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  const t16 = `${t.client} Logo`;
  let t17;
  if ($[46] !== t16) {
    t17 = <div className="flex items-center justify-end gap-x-8 text-sm lg:gap-x-12 xl:gap-x-20">{t15}<CustomImage alt={t16} data-source="lc" height={29} src="images/logo/logo_footer.svg" width={100} /></div>;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t14 || $[49] !== t17) {
    t18 = <footer className="outer-container justify-center bg-white py-6 text-foreground print:hidden"><div className="inner-container flex flex-col justify-between lg:flex-row lg:justify-between">{t14}{t17}</div></footer>;
    $[48] = t14;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  return t18;
}
function _temp3() {
  return window.UC_UI?.showSecondLayer();
}
function _temp2(link) {
  return <li key={link.href}><CustomLink blank={true} className="text-foreground first:ml-0 hover:text-primary md:mx-3" data-source="lc" href={link.href}>{link.text}</CustomLink></li>;
}
function _temp(social) {
  return <li key={social.href}><SocialLink aria-label={social.title} className="flex shadow-none" classNameIcon="text-foreground" href={social.href} social={social.platform} title={social.title} /></li>;
}